import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../../environments/urlService';
import { EmployeeDTO } from "../dto/EmployeeDTO";
import { IS_SPINNER_ACTIVE } from "../../../../util/interceptors";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private readonly url: string;
  private http = inject(HttpClient);
  private urlService = inject(UrlService);

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'employee/';
  }

  get(orgUUID: string): Observable<EmployeeDTO[]> {
    return this.http.get<EmployeeDTO[]>(this.url + 'by-organization', {
      params: { orgUUID },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  create(employee: EmployeeDTO): Observable<EmployeeDTO> {
    return this.http.post<EmployeeDTO>(this.url, employee, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  update(employeeDTO: EmployeeDTO): Observable<void> {
    return this.http.put<void>(this.url, employeeDTO, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  delete(uuid: string): Observable<void> {
    return this.http.delete<void>(`${this.url}${uuid}`, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  reInviteUser(employee: EmployeeDTO): Observable<void> {
    return this.http.post<void>(this.url + 'reinvite', employee, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}

